export default function BeforeAfter() {
  return (
    <section className="py-20 bg-gradient-to-b from-emerald-50/30 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Real Results, Real Women
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            See the transformative power of our premium products
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="relative">
            <div className="rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://public.readdy.ai/ai/img_res/a9bde5dcf0563e207bebaaa9cbc69320.jpg"
                alt="Radiant skin results"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 bg-white rounded-2xl p-6 shadow-xl">
              <div className="text-center">
                <div className="text-3xl font-bold text-emerald-600 mb-1">30 Days</div>
                <div className="text-sm text-gray-600">Visible Results</div>
              </div>
            </div>
          </div>

          <div className="space-y-8">
            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-checkbox-circle-fill text-2xl text-emerald-600"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Clearer Skin</h3>
                  <p className="text-gray-600">
                    Our vitamin C serum and natural skincare products help reduce blemishes and even skin tone for a radiant complexion.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-heart-pulse-fill text-2xl text-emerald-600"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">More Energy</h3>
                  <p className="text-gray-600">
                    Premium multivitamins and omega-3 supplements boost your daily energy levels and overall vitality naturally.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-sparkle-fill text-2xl text-emerald-600"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Youthful Glow</h3>
                  <p className="text-gray-600">
                    Collagen peptides and retinol treatments work together to reduce fine lines and restore your natural radiance.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
